import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dom = $(el);
    const expandables = dom.find('[aria-expanded]');
    const triggers = dom.find('[data-trigger]');

    const toggle = expandable => {
        const shouldOpen = expandable.attr('aria-expanded') === 'false';

        expandable.toggleClass('fill-blue', shouldOpen);
        expandable.previous().toggleClass('c-blue', shouldOpen);
        expandable.find('svg').eq(0).attr('hidden', shouldOpen ? '' : null);
        expandable.find('svg').eq(1).attr('hidden', shouldOpen ? null : '');

        if (shouldOpen) {
            expandable.attr('aria-expanded', true).attr('aria-label', expandable.data('close'));
            expandable.next().attr('hidden', null);
        } else {
            expandable.attr('aria-expanded', false).attr('aria-label', expandable.data('label'));
            expandable.next().attr('hidden', '');
        }
    };

    const init = () => {
        const path = document.location.pathname;
        expandables.each(node => {
            const exp = $(node);
            exp.previous().find('span').remove();
            exp.data('label', exp.attr('aria-label'));
            if (path.indexOf(exp.previous().get(0).pathname) > -1) {
                toggle(exp);
            }
        });
        dom.find('[data-link]').each(node => {
            if (path.indexOf(node.pathname) > -1) {
                $(node).addClass('c-blue fill-blue');
            }
        });
        expandables.on('click', e => {
            toggle($(e.triggerTarget));
        });
        triggers.on('click', e => {
            $(e.triggerTarget).next().get(0).click();
        });
    };

    const destroy = () => {
        expandables.off('click');
        triggers.off('click');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Expandables.js